webpackJsonp([43],{

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Utility__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Notification',
  data: function data() {
    return {
      width: '45%',
      top: '45%',
      notificationList: null,
      emptyNotification: false
    };
  },

  props: ['closePopupCB'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['fcm_notifications'])),
  components: {
    Popup: function Popup() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 70));
    }
  },
  created: function created() {
    this.commitFCMNotifications(false);
  },
  mounted: function mounted() {
    this.getNotificationList();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])(['commitFCMNotifications']), {
    getNotificationList: function getNotificationList() {
      if (this.fcm_notifications) {
        this.notificationList = [];
        this.notificationList = this.fcm_notifications;
      } else {
        this.emptyNotification = true;
      }
    },
    closePopup: function closePopup() {
      // Hide the popup
      this.closePopupCB();
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Utility__["a" /* default */]]

});

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(324);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451aacc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(405);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-451aacc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451aacc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("25065b06", content, true, {});

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".notification-container[data-v-451aacc8]{padding:10px}.notification-slider[data-v-451aacc8]{padding:10px 0}.notification-slide-controls img[data-v-451aacc8]{width:35px}.notification-slide-controls .btn-slide-controls[data-v-451aacc8]{background-color:transparent;border:0;cursor:pointer}.notification-slide-controls .btn-slide-controls[data-v-451aacc8]:disabled{cursor:not-allowed;opacity:.3}.notification-slide-controls .prev[data-v-451aacc8]{position:absolute;z-index:100;top:55%;left:1%}.notification-slide-controls .next[data-v-451aacc8]{position:absolute;right:1%;top:55%;z-index:100}#car-slider-notification[data-v-451aacc8]{max-height:450px;overflow:auto}#car-slider-notification[data-v-451aacc8]::-webkit-scrollbar{width:6px}#car-slider-notification[data-v-451aacc8]::-webkit-scrollbar-track{border-radius:15px}#car-slider-notification[data-v-451aacc8]::-webkit-scrollbar-thumb{background:#b9bcb9;border-radius:15px}.notify-container[data-v-451aacc8]{margin:2%}.notify-container .notify-header[data-v-451aacc8]{margin:1% 0}.notify-container .notify-header div[data-v-451aacc8]{padding:0}.notify-container .notify-header h2[data-v-451aacc8]{color:#000;font-size:18px;letter-spacing:1px;font-family:ProximanovaBold;word-break:break-word}.notify-container .notify-header p[data-v-451aacc8]{color:#000;font-size:15px;letter-spacing:1px;font-family:ProximanovaRegular;text-align:end}.notify-container p[data-v-451aacc8]{color:#000;font-size:15px;letter-spacing:1px;font-family:ProximanovaRegular;word-break:break-word}.notify-container .notify-img-container[data-v-451aacc8]{width:100%;height:300px;margin-bottom:10px}.notify-container .notify-img-container img[data-v-451aacc8]{border-radius:10px}.hr[data-v-451aacc8]{width:100%;height:2px;margin:4% 0;border-bottom:1px solid #9090904d}.no-notification[data-v-451aacc8]{text-align:center;color:#000;font-size:20px;letter-spacing:1px;font-family:ProximanovaRegular;word-break:break-word}@media only screen and (max-width:600px){.notify-container .notify-time[data-v-451aacc8]{text-align:end}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/Notification.vue"],"names":[],"mappings":"AACA,yCAAyC,YAAY,CACpD,AACD,sCAAsC,cAAc,CACnD,AACD,kDAAkD,UAAU,CAC3D,AACD,kEAAkE,6BAA6B,SAAS,cAAc,CACrH,AACD,2EAA2E,mBAAmB,UAAW,CACxG,AACD,oDAAoD,kBAAkB,YAAY,QAAQ,OAAO,CAChG,AACD,oDAAoD,kBAAkB,SAAS,QAAQ,WAAW,CACjG,AACD,0CAA0C,iBAAiB,aAAa,CACvE,AACD,6DAA6D,SAAS,CACrE,AACD,mEAAmE,kBAAkB,CACpF,AACD,mEAAmE,mBAAmB,kBAAkB,CACvG,AACD,mCAAmC,SAAS,CAC3C,AACD,kDAAkD,WAAW,CAC5D,AACD,sDAAsD,SAAS,CAC9D,AACD,qDAAqD,WAAc,eAAe,mBAAmB,4BAA8B,qBAAqB,CACvJ,AACD,oDAAoD,WAAc,eAAe,mBAAmB,+BAAiC,cAAc,CAClJ,AACD,qCAAqC,WAAc,eAAe,mBAAmB,+BAAiC,qBAAqB,CAC1I,AACD,yDAAyD,WAAW,aAAa,kBAAkB,CAClG,AACD,6DAA6D,kBAAkB,CAC9E,AACD,qBAAqB,WAAW,WAAW,YAAY,iCAAiC,CACvF,AACD,kCAAkC,kBAAkB,WAAc,eAAe,mBAAmB,+BAAiC,qBAAqB,CACzJ,AACD,yCACA,gDAAgD,cAAc,CAC7D,CACA","file":"Notification.vue","sourcesContent":["\n.notification-container[data-v-451aacc8]{padding:10px\n}\n.notification-slider[data-v-451aacc8]{padding:10px 0\n}\n.notification-slide-controls img[data-v-451aacc8]{width:35px\n}\n.notification-slide-controls .btn-slide-controls[data-v-451aacc8]{background-color:transparent;border:0;cursor:pointer\n}\n.notification-slide-controls .btn-slide-controls[data-v-451aacc8]:disabled{cursor:not-allowed;opacity:0.3\n}\n.notification-slide-controls .prev[data-v-451aacc8]{position:absolute;z-index:100;top:55%;left:1%\n}\n.notification-slide-controls .next[data-v-451aacc8]{position:absolute;right:1%;top:55%;z-index:100\n}\n#car-slider-notification[data-v-451aacc8]{max-height:450px;overflow:auto\n}\n#car-slider-notification[data-v-451aacc8]::-webkit-scrollbar{width:6px\n}\n#car-slider-notification[data-v-451aacc8]::-webkit-scrollbar-track{border-radius:15px\n}\n#car-slider-notification[data-v-451aacc8]::-webkit-scrollbar-thumb{background:#b9bcb9;border-radius:15px\n}\n.notify-container[data-v-451aacc8]{margin:2%\n}\n.notify-container .notify-header[data-v-451aacc8]{margin:1% 0\n}\n.notify-container .notify-header div[data-v-451aacc8]{padding:0\n}\n.notify-container .notify-header h2[data-v-451aacc8]{color:#000000;font-size:18px;letter-spacing:1px;font-family:\"ProximanovaBold\";word-break:break-word\n}\n.notify-container .notify-header p[data-v-451aacc8]{color:#000000;font-size:15px;letter-spacing:1px;font-family:\"ProximanovaRegular\";text-align:end\n}\n.notify-container p[data-v-451aacc8]{color:#000000;font-size:15px;letter-spacing:1px;font-family:\"ProximanovaRegular\";word-break:break-word\n}\n.notify-container .notify-img-container[data-v-451aacc8]{width:100%;height:300px;margin-bottom:10px\n}\n.notify-container .notify-img-container img[data-v-451aacc8]{border-radius:10px\n}\n.hr[data-v-451aacc8]{width:100%;height:2px;margin:4% 0;border-bottom:1px solid #9090904d\n}\n.no-notification[data-v-451aacc8]{text-align:center;color:#000000;font-size:20px;letter-spacing:1px;font-family:\"ProximanovaRegular\";word-break:break-word\n}\n@media only screen and (max-width: 600px){\n.notify-container .notify-time[data-v-451aacc8]{text-align:end\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"width":_vm.width,"top":_vm.top,"closePopupEvent":_vm.closePopupCB}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h6',{staticClass:"login-header"},[_vm._v("Notifications")])]),_vm._v(" "),_c('div',{staticClass:"notification-container"},[(_vm.emptyNotification)?_c('h4',{staticClass:"no-notification"},[_vm._v("No new notification")]):_vm._e(),_vm._v(" "),(!_vm.emptyNotification)?_c('div',{staticClass:"notification-slider"},[_c('div',{staticClass:"car-slider",attrs:{"id":"car-slider-notification"}},_vm._l((_vm.notificationList),function(notification,i){return _c('div',{key:i,staticClass:"car-slide"},[_c('div',{staticClass:"notify-container"},[(notification.data.image_url)?_c('div',{staticClass:"notify-img-container"},[_c('img',{attrs:{"src":notification.data.image_url,"width":"100%","height":"100%"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notify-header row"},[_c('div',{staticClass:"col-xlg-10 col-lg-10 col-sm-10 col-xs-8 col-md-10"},[_c('h2',[_vm._v(_vm._s(notification.data.title))])]),_vm._v(" "),_c('div',{staticClass:"col-xlg-2 col-lg-2 col-sm-2 col-xs-4 col-md-2"},[(notification.timestamp)?_c('p',{staticClass:"notify-time"},[_vm._v("\n                    "+_vm._s(_vm.parseToAppTime(notification.timestamp))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(notification.data.message))]),_vm._v(" "),(i !== (_vm.notificationList.length - 1))?_c('div',{staticClass:"hr"}):_vm._e()])])}),0)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/43.6a80773bbab0d2b43c04.js